import React, { useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { icons, images } from "../../assets";
import AuthLayout from "../../components/authLayout";
import CustomButton from "../../components/customButton";
import { useLocation, useNavigate } from "react-router-dom";
import AppLoader from "../../components/appLoader";
import { openSnackAlert } from "../../helper";
const OtpVerification = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;

  const handleChange = (index, event) => {
    const value = event.target.value;
    if (isNaN(value)) return;

    let newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleSubmit = () => {
    if (otp.every((digit) => digit !== "")) {
      navigate("/set-new-password", {
        state: { email, otp: otp.join("") },
      });
    } else {
      openSnackAlert("Please enter a complete OTP.", "error");
    }
  };

  return (
    <AuthLayout>
      <Box
        p={6}
        py={4}
        mt={3}
        width={{ xs: 400, sm: 520 }}
        bgcolor="#fff"
        borderRadius="16px"
        boxShadow="0 4px 30px rgba(0, 0, 0, 0.1)"
      >
        <Box
          sx={{
            textDecoration: "none",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <img
            src={icons.applogo}
            alt="Capacity&Care"
            style={{ height: "60px" }}
          />
        </Box>
        <Typography textAlign={"center"} my={3} fontSize={14} fontWeight={600}>
          OTP VERIFICATION
        </Typography>
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="label" mb={2}>
            Enter the OTP sent to your email address
          </Typography>
        </Box>

        <Box display="flex" justifyContent="center" my={2} mb={6} gap={1}>
          {otp.map((digit, index) => (
            <TextField
              key={index}
              id={`otp-${index}`}
              value={digit}
              onChange={(e) => handleChange(index, e)}
              variant="outlined"
              inputProps={{
                maxLength: 1,
                style: {
                  textAlign: "center",
                  fontSize: "24px",
                  backgroundColor: "#fff",
                  borderRadius: "4px",
                },
              }}
              sx={{ width: "50px", height: "50px" }}
            />
          ))}
        </Box>

        <CustomButton
          width={"100%"}
          btnLabel={"Verify"}
          variant="authbutton"
          borderRadius="28px"
          btnTextColor={"#ffff"}
          height={"50px"}
          handlePressBtn={handleSubmit}
        />
      </Box>
    </AuthLayout>
  );
};

export default OtpVerification;
